module.exports = __webpack_public_path__ + "img/very-main-desk.c31743af.jpg";